import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import NotificationBannerSkeleton from './NotificationBannerSkeleton';
const BagSaved = t0 => {
  const $ = _c(7);
  const {
    result,
    onClose,
    email
  } = t0;
  const t1 = result === "success" ? "Your bag has been saved!" : "Error sending email";
  let t2;
  if ($[0] !== email || $[1] !== result) {
    t2 = <span>{result === "success" ? <>We sent a link to <span className="text-brand">{email}</span> where you can access it any time.</> : <>Something went wrong, email could not be sent.</>}</span>;
    $[0] = email;
    $[1] = result;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose || $[4] !== t1 || $[5] !== t2) {
    t3 = <NotificationBannerSkeleton title={t1} body={t2} onClose={onClose} />;
    $[3] = onClose;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
BagSaved.propTypes = {
  result: PropTypes.string,
  onClose: PropTypes.func,
  email: PropTypes.string
};
export default BagSaved;